import { z } from 'zod/v4'

export const userPaymentValidation = () => {
  return z.object({
    payment_id: z.string().min(1, { message: 'Form is required' }),
    remarks: z.string().min(1, { message: 'Form is required' }),
    value: z.string().min(1, { message: 'Form is required' }),
  })
}

export const userCreditValidation = () => {
  return z.object({
    created_at: z.date({ message: 'Date is required' }).min(1, { message: 'Date is required' }),
    label: z.string().min(1, { message: 'Form is required' }),
    method: z.string().min(1, { message: 'Form is required' }),
    amount: z.coerce.number({ message: 'Amount is required' }).min(1, { message: 'A mount must higher than 0' }),
    order_id: z.string().nullable().optional(),
    supplier_id: z.string().nullable().optional(),
  }).refine(
    (data) => {
      if (data.label === 'Order Commision' || data.label === 'Sales') {
        return data.order_id !== null && data.order_id !== ''
      }
      return true
    }, {
      message: 'Form is required',
      path: ['order_id']
    }
  ).refine(
    (data) => {
      if (data.label === 'Sales') {
        return data.supplier_id !== null && data.supplier_id !== ''
      }
      return true
    }, {
      message: 'Form is required',
      path: ['supplier_id']
    }
  )
}